import { createSelector } from 'reselect'

export const getDocumentSources = (state, props) => {
  return state.kanbo.documentSources.documentSources
}

export const getDocumentSourcesById = (state, props) => {
  return state.kanbo.documentSources.documentSourcesById
}

export const makeDocumentSourcesSelector = () => createSelector(
  [getDocumentSources, getDocumentSourcesById],
  (documentSources, documentSourcesById) => {
    return documentSources.map(id => documentSourcesById[id])
  }
)

export const documentSourcesSelector = makeDocumentSourcesSelector()
